import { Component, input } from '@angular/core';

export type AdminSkeletonVariant = 'title' | 'text' | 'card';

@Component({
  selector: 'app-admin-skeleton',
  standalone: true,
  template: `<div [class]="'cg-admin-skeleton cg-admin-skeleton--' + variant()" [attr.aria-hidden]="true"></div>`,
})
export class AdminSkeletonComponent {
  readonly variant = input<AdminSkeletonVariant>('text');
}
